import { useMutation, useQueryClient } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** Emails invited owners a fresh set-password link; earlier links stop working. */
export function useResendOwnerInvite(organizationId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => organizationsApi.resendOwnerInvite(organizationId),
    meta: { successMessage: 'organizations:toasts.inviteResent' },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: organizationKeys.detail(organizationId) }),
  });
}
